var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "V3",
    clipPath: "url(#clip0_7505_1312)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26 28C26 29.1 25.1 30 24 30H4C2.9 30 2 29.1 2 28V4C2 2.9 2.9 2 4 2H16V11C16 11.6 16.4 12 17 12H26V14H28V11L27.3 10.3L17.7 0.7L17 0H4C1.8 0 0 1.8 0 4V28C0 30.2 1.8 32 4 32H24C26.2 32 28 30.2 28 28V27H26V28ZM18 3.8L24.2 10H18V3.8Z",
    fill: "#1B1C1F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.2 19.2C19.2 20 19 20.6 18.5 21C18 21.4 17.3 21.6 16.5 21.6H15.9V24.1H14.4V17H16.7C17.6 17 18.2 17.2 18.7 17.6C18.9 17.9 19.2 18.4 19.2 19.2ZM15.7 20.3H16.2C16.7 20.3 17 20.2 17.2 20C17.4 19.8 17.5 19.5 17.5 19.2C17.5 18.8 17.4 18.6 17.2 18.4C17 18.2 16.7 18.1 16.3 18.1H15.6V20.3H15.7Z",
    fill: "#1B1C1F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M26.4 20.4004C26.4 21.6004 26.1 22.5004 25.4 23.1004C24.7 23.7004 23.8 24.0004 22.5 24.0004H20.5V16.9004H22.7C23.9 16.9004 24.8 17.2004 25.4 17.8004C26 18.4004 26.4 19.3004 26.4 20.4004ZM24.9 20.5004C24.9 19.0004 24.2 18.2004 22.9 18.2004H22V22.8004H22.6C24.1 22.8004 24.9 22.1004 24.9 20.5004Z",
    fill: "#1B1C1F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M29.4 24.1H27.9V17H32V18.2H29.4V20H31.8V21.2H29.4V24.1Z",
    fill: "#1B1C1F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7505_1312"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf-icon.b017b8742be1ce7b0c27d5893d6b8335.svg";
export { ForwardRef as ReactComponent };